/**
 * @file 数据加密
 * @author svon.me@gmail.com
 **/

import CryptoJS from 'crypto-js';

/** md5 加密*/
export const md5 = function (value: string): string {
  return CryptoJS.MD5(value).toString();
}